const prefix = 'LIBRARY_PROMO';

export const LIBRARY_PROMO_PAGE_REQUEST = `${prefix}_PAGE_REQUEST`;

export const LIBRARY_PROMO_ON_CLICK_CREATE_PROMO = `${prefix}_ON_CLICK_CREATE_PROMO`;

export const LIBRARY_PROMO_OPEN_RIGHT_COLUMN = `${prefix}_OPEN_RIGHT_COLUMN`;

export const LIBRARY_PROMO_CLOSE_RIGHT_COLUMN = `${prefix}_CLOSE_RIGHT_COLUMN`;

export const LIBRARY_PROMO_ON_CLICK_CANCEL_PROMO = `${prefix}_ON_CLICK_CANCEL_PROMO`;

export const LIBRARY_PROMO_SET_ACCORDION_ACTIVE_KEY = `${prefix}_SET_ACCORDION_ACTIVE_KEY`;

export const LIBRARY_PROMO_SET_PROMO_TYPES = `${prefix}_SET_PROMO_TYPES`;

export const LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_MODAL = `${prefix}_SHOW_ASSIGN_OUTLET_MODAL`;

export const LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_MODAL = `${prefix}_HIDE_ASSIGN_OUTLET_MODAL`;

export const LIBRARY_PROMO_SET_OUTLETS = `${prefix}_SET_OUTLETS`;

export const LIBRARY_PROMO_ON_CLICK_ASSIGN_OUTLET = `${prefix}_ON_CLICK_ASSIGN_OUTLET`;

export const LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_OUTLET_MODAL = `${prefix}_ON_CLICK_CANCEL_ASSIGN_OUTLET_MODAL`;

export const LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_OUTLET_MODAL = `${prefix}_ON_CLICK_ASSIGN_PROMO_ASSIGN_OUTLET_MODAL`;

export const LIBRARY_PROMO_SEARCH_OUTLET = `${prefix}_SEARCH_OUTLET`;

export const LIBRARY_PROMO_SELECT_ALL_OUTLETS = `${prefix}_SELECT_ALL_OUTLETS`;

export const LIBRARY_PROMO_SET_SELECTED_OUTLETS = `${prefix}_SET_SELECTED_OUTLETS`;

export const LIBRARY_PROMO_UNSELECT_ALL_OUTLETS = `${prefix}_UNSELECT_ALL_OUTLETS`;

export const LIBRARY_PROMO_ON_SUBMIT_EACH_PROMO_FORM = `${prefix}_ON_SUBMIT_EACH_PROMO_FORM`;

export const LIBRARY_PROMO_SET_IS_SUBMITTED_EACH_PROMO_FORM = `${prefix}_SET_IS_SUBMITTED_EACH_PROMO_FORM`;

export const LIBRARY_PROMO_ON_SUBMIT_FIRST_FORM = `${prefix}_ON_SUBMIT_FIRST_FORM`;

export const LIBRARY_PROMO_GET_ALL_AVAILABLE_ITEMS_AND_CATEGORIES = `${prefix}_GET_ALL_AVAILABLE_ITEMS_AND_CATEGORIES`;

export const LIBRARY_PROMO_SET_INTERSECT_ITEMS = `${prefix}_SET_INTERSECT_ITEMS`;

export const LIBRARY_PROMO_SET_INTERSECT_CATEGORIES = `${prefix}_SET_INTERSECT_CATEGORIES`;

export const LIBRARY_PROMO_SET_IS_SUBMITTING_FORM = `${prefix}_SET_IS_SUBMITTING_FORM`;

export const LIBRARY_PROMO_SET_INTERSECT_VARIANTS = `${prefix}_SET_INTERSECT_VARIANTS`;

export const LIBRARY_PROMO_ON_CHANGE_PR_BUY_X_GET_Y = `${prefix}_ON_CHANGE_PR_BUY_X_GET_Y`;

export const LIBRARY_PROMO_ON_SUBMIT_SECOND_FORM = `${prefix}_ON_SUBMIT_SECOND_FORM`;

export const LIBRARY_PROMO_ON_CHANGE_ITEM_REWARD_BUY_X_GET_Y = `${prefix}_ON_CHANGE_ITEM_REWARD_BUY_X_GET_Y`;

export const LIBRARY_PROMO_ON_CHANGE_SWITCH_FIELD_DISCOUNT = `${prefix}_ON_CHANGE_SWITCH_FIELD_DISCOUNT`;

export const LIBRARY_PROMO_ON_SUBMIT_THIRD_FORM = `${prefix}_ON_SUBMIT_THIRD_FORM`;

export const LIBRARY_PROMO_ON_CREATE_PROMO_BUY_X_GET_Y = `${prefix}_ON_CREATE_PROMO_BUY_X_GET_Y`;

export const LIBRARY_PROMO_GET_LIST_PROMO_REQUEST = `${prefix}_GET_LIST_PROMO_REQUEST`;

export const LIBRARY_PROMO_SET_LIST_PROMO = `${prefix}_SET_LIST_PROMO`;

export const LIBRARY_PROMO_SET_TOTAL_PAGE = `${prefix}_SET_TOTAL_PAGE`;

export const LIBRARY_PROMO_SET_CURRENT_PAGE = `${prefix}_SET_CURRENT_PAGE`;

export const LIBRARY_PROMO_ON_CLICK_ROW = `${prefix}_ON_CLICK_ROW`;

export const LIBRARY_PROMO_SET_DETAIL_PROMO = `${prefix}_SET_DETAIL_PROMO`;

export const LIBRARY_PROMO_ON_CLICK_DELETE = `${prefix}_ON_CLICK_DELETE`;

export const LIBRARY_PROMO_SHOW_DELETE_MODAL = `${prefix}_SHOW_DELETE_MODAL`;

export const LIBRARY_PROMO_HIDE_DELETE_MODAL = `${prefix}_HIDE_DELETE_MODAL`;

export const LIBRARY_PROMO_CANCEL_DELETE = `${prefix}_CANCEL_DELETE`;

export const LIBRARY_PROMO_DELETE_PROMO = `${prefix}_DELETE_PROMO`;

export const LIBRARY_PROMO_SET_DELETED_PROMO = `${prefix}_SET_DELETED_PROMO`;

export const LIBRARY_PROMO_ON_CLICK_DEACTIVATE = `${prefix}_ON_CLICK_DEACTIVATE`;

export const LIBRARY_PROMO_SHOW_DEACTIVATE_MODAL = `${prefix}_SHOW_DEACTIVATE_MODAL`;

export const LIBRARY_PROMO_HIDE_DEACTIVATE_MODAL = `${prefix}_HIDE_DEACTIVATE_MODAL`;

export const LIBRARY_PROMO_CANCEL_DEACTIVATE = `${prefix}_CANCEL_DEACTIVATE`;

export const LIBRARY_PROMO_DEACTIVATE_PROMO = `${prefix}_DEACTIVATE_PROMO`;

export const LIBRARY_PROMO_SET_DEACTIVATED_PROMO = `${prefix}_SET_DEACTIVATED_PROMO`;

export const LIBRARY_PROMO_ON_CLICK_REACTIVATE = `${prefix}_ON_CLICK_REACTIVATE`;

export const LIBRARY_PROMO_SHOW_REACTIVATE_MODAL = `${prefix}_SHOW_REACTIVATE_MODAL`;

export const LIBRARY_PROMO_HIDE_REACTIVATE_MODAL = `${prefix}_HIDE_REACTIVATE_MODAL`;

export const LIBRARY_PROMO_CANCEL_REACTIVATE = `${prefix}_CANCEL_REACTIVATE`;

export const LIBRARY_PROMO_REACTIVATE_PROMO = `${prefix}_REACTIVATE_PROMO`;

export const LIBRARY_PROMO_SET_REACTIVATED_PROMO = `${prefix}_SET_REACTIVATED_PROMO`;

export const LIBRARY_PROMO_UPDATE_PROMO = `${prefix}_UPDATE_PROMO`;

/** actions for confirmation reactivate modal when promo does not have time period * */
export const LIBRARY_PROMO_SHOW_CONFIRM_REACTIVATE_MODAL = `${prefix}_SHOW_CONFIRM_REACTIVATE_MODAL`;

export const LIBRARY_PROMO_HIDE_CONFIRM_REACTIVATE_MODAL = `${prefix}_HIDE_CONFIRM_REACTIVATE_MODAL`;

export const LIBRARY_PROMO_CANCEL_CONFIRM_REACTIVATE = `${prefix}_CANCEL_CONFIRM_REACTIVATE`;

export const LIBRARY_PROMO_CONFIRM_REACTIVATE_PROMO = `${prefix}_CONFIRM_REACTIVATE_PROMO`;

export const LIBRARY_PROMO_SET_PREV_ASSIGNED_OUTLETS = `${prefix}_SET_PREV_ASSIGNED_OUTLETS`;

export const LIBRARY_PROMO_ON_CHANGE_PROMO_TYPES = `${prefix}_ON_CHANGE_PROMO_TYPES`;

export const LIBRARY_PROMO_ON_CHANGE_STATUS = `${prefix}_ON_CHANGE_STATUS`;

export const LIBRARY_PROMO_ON_CHANGE_KEYWORD = `${prefix}_ON_CHANGE_KEYWORD`;

export const LIBRARY_PROMO_ON_REACH_BUTTOM = `${prefix}_ON_REACH_BUTTOM`;

/** action constants of update confirmation for manager user * */
export const LIBRARY_PROMO_ASK_CONFIRMATION_UPDATE = `${prefix}_ASK_CONFIRMATION_UPDATE`;

export const LIBRARY_PROMO_SHOW_UPDATE_CONFIRM_MODAL = `${prefix}_SHOW_UPDATE_CONFIRM_MODAL`;

export const LIBRARY_PROMO_HIDE_UPDATE_CONFIRM_MODAL = `${prefix}_HIDE_UPDATE_CONFIRM_MODAL`;

export const LIBRARY_PROMO_ON_CANCEL_UPDATE_CONFIRMATION = `${prefix}_ON_CANCEL_UPDATE_CONFIRMATION`;

export const LIBRARY_PROMO_ON_CONFIRM_UPDATE = `${prefix}_ON_CONFIRM_UPDATE`;

export const LIBRARY_PROMO_SET_NEXT_UPDATE_ACTION = `${prefix}_SET_NEXT_UPDATE_ACTION`;

export const LIBRARY_PROMO_SET_ACTION_UPDATE_NAME = `${prefix}_SET_ACTION_UPDATE_NAME`;

/** actions constants for gostore price cuts promo * */
export const LIBRARY_PROMO_ON_CLICK_ASSIGN_ITEMS = `${prefix}_ON_CLICK_ASSIGN_ITEMS`;

export const LIBRARY_PROMO_SHOW_ASSIGN_ITEMS_MODAL = `${prefix}_SHOW_ASSIGN_ITEMS_MODAL`;

export const LIBRARY_PROMO_HIDE_ASSIGN_ITEMS_MODAL = `${prefix}_HIDE_ASSIGN_ITEMS_MODAL`;

export const LIBRARY_PROMO_SET_CATEGORIES = `${prefix}_SET_CATEGORIES`;

export const LIBRARY_PROMO_SET_ITEM_DETAILS = `${prefix}_SET_ITEM_DETAILS`;

export const LIBRARY_PROMO_ASSIGN_ITEMS_ON_CLICK_CANCEL = `${prefix}_ASSIGN_ITEMS_ON_CLICK_CANCEL`;

export const LIBRARY_PROMO_ASSIGN_ITEMS_ON_CHANGE_SEARCH = `${prefix}_ASSIGN_ITEMS_ON_CHANGE_SEARCH`;

export const LIBRARY_PROMO_ASSIGN_ITEMS_ON_CHANGE_CATEGORY = `${prefix}_ASSIGN_ITEMS_ON_CHANGE_CATEGORY`;

export const LIBRARY_PROMO_ASSIGN_ITEMS_ON_CLICK_ASSIGN_ITEMS = `${prefix}_ASSIGN_ITEMS_ON_CLICK_ASSIGN_ITEMS`;

export const LIBRARY_PROMO_ASSIGN_ITEMS_SET_ASSIGNED_PROMOS = `${prefix}_ASSIGN_ITEMS_SET_ASSIGNED_PROMOS`;

export const LIBRARY_PROMO_ON_CREATE_GOSTORE_PRICE_CUTS_PROMO = `${prefix}_ON_CREATE_GOSTORE_PRICE_CUTS_PROMO`;

export const LIBRARY_PROMO_ON_CREATE_ADVANCE_PROMO = `${prefix}_ON_CREATE_ADVANCE_PROMO`;

export const LIBRARY_PROMO_ON_UPDATE_ADVANCE_PROMO = `${prefix}_ON_UPDATE_ADVANCE_PROMO`;

export const LIBRARY_PROMO_SELECT_APPLY_DISCOUNT_TO_ALL_ITEMS = `${prefix}_SELECT_APPLY_DISCOUNT_TO_ALL_ITEMS`;

export const LIBRARY_PROMO_SET_NON_DELETED_PROMOS = `${prefix}_SET_NON_DELETED_PROMOS`;

export const LIBRARY_PROMO_SET_ERRORS_PRICE_CUTS_PROMO = `${prefix}_SET_ERRORS_PRICE_CUTS_PROMO`;

export const LIBRARY_PROMO_SHOW_ERROR_MODAL_PRICE_CUTS_PROMO = `${prefix}_SHOW_ERROR_MODAL_PRICE_CUTS_PROMO`;

export const LIBRARY_PROMO_HIDE_ERROR_MODAL_PRICE_CUTS_PROMO = `${prefix}_HIDE_ERROR_MODAL_PRICE_CUTS_PROMO`;

export const LIBRARY_PROMO_REACTIVATE_GOSTORE_PRICE_CUTS_PROMO = `${prefix}_REACTIVATE_GOSTORE_PRICE_CUTS_PROMO`;

export const LIBRARY_PROMO_ON_UPDATE_GOSTORE_PRICE_CUTS_PROMO = `${prefix}_ON_UPDATE_GOSTORE_PRICE_CUTS_PROMO`;

export const LIBRARY_PROMO_ON_CLICK_ROW_GOSTORE_PRICE_CUTS_PROMO = `${prefix}_ON_CLICK_ROW_GOSTORE_PRICE_CUTS_PROMO`;

export const LIBRARY_PROMO_ASSIGN_ITEMS_SET_TOTAL_PAGE = `${prefix}_ASSIGN_ITEMS_SET_TOTAL_PAGE`;

export const LIBRARY_PROMO_ASSIGN_ITEMS_SET_CURRENT_PAGE = `${prefix}_ASSIGN_ITEMS_SET_CURRENT_PAGE`;

export const LIBRARY_PROMO_ASSIGN_ITEMS_ON_REACH_BUTTOM = `${prefix}_ASSIGN_ITEMS_ON_REACH_BUTTOM`;

export const LIBRARY_PROMO_SET_SELECTED_GOSTORE_ITEMS = `${prefix}_SET_SELECTED_GOSTORE_ITEMS`;

/** action constans for promo by sales type */
export const LIBRARY_PROMO_SHOW_ASSIGN_SALES_TYPE_MODAL = `${prefix}_SHOW_ASSIGN_SALES_TYPE_MODAL`;

export const LIBRARY_PROMO_HIDE_ASSIGN_SALES_TYPE_MODAL = `${prefix}_HIDE_ASSIGN_SALES_TYPE_MODAL`;

export const LIBRARY_PROMO_SET_SALES_TYPES = `${prefix}_SET_SALES_TYPES`;

export const LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_SALES_TYPE_MODAL = `${prefix}_ON_CLICK_ASSIGN_PROMO_ASSIGN_SALES_TYPE_MODAL`;

export const LIBRARY_PROMO_ON_CHANGE_SALES_TYPE_NAMESPACE = `${prefix}_ON_CHANGE_SALES_TYPE_NAMESPACE`;

export const LIBRARY_PROMO_ON_CLICK_ASSIGN_SALES_TYPE = `${prefix}_ON_CLICK_ASSIGN_SALES_TYPE`;

export const LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_SALES_TYPE_MODAL = `${prefix}_ON_CLICK_CANCEL_ASSIGN_SALES_TYPE_MODAL`;

export const LIBRARY_PROMO_UNSELECT_ALL_SALES_TYPES = `${prefix}_UNSELECT_ALL_SALES_TYPES`;

export const LIBRARY_PROMO_SEARCH_SALES_TYPE = `${prefix}_SEARCH_SALES_TYPE`;

export const LIBRARY_PROMO_SELECT_ALL_SALES_TYPES = `${prefix}_SELECT_ALL_SALES_TYPES`;

export const LIBRARY_PROMO_SET_SELECTED_SALES_TYPES = `${prefix}_SET_SELECTED_SALES_TYPES`;

export const LIBRARY_PROMO_SET_SALES_TYPE_NAMESPACE = `${prefix}_SET_SALES_TYPE_NAMESPACE`;

export const LIBRARY_PROMO_SET_ALREADY_ASSIGNED_OUTLET = `${prefix}_SET_ALREADY_ASSIGNED_OUTLET`;

export const LIBRARY_PROMO_ON_CHANGE_ALREADY_ASSIGNED_OUTLET = `${prefix}_ON_CHANGE_ALREADY_ASSIGNED_OUTLET`;

export const LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_WARN_MODAL = `${prefix}_SHOW_ASSIGN_OUTLET_WARN_MODAL`;

export const LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_WARN_MODAL = `${prefix}_HIDE_ASSIGN_OUTLET_WARN_MODAL`;

export const LIBRARY_PROMO_ON_CONFIRM_ASSIGN_OUTLET_WARN_MODAL = `${prefix}_ON_CONFIRM_ASSIGN_OUTLET_WARN_MODAL`;

export const LIBRARY_PROMO_SHOW_ASSIGN_OUTLET_WARN = `${prefix}_SHOW_ASSIGN_OUTLET_WARN`;

export const LIBRARY_PROMO_HIDE_ASSIGN_OUTLET_WARN = `${prefix}_HIDE_ASSIGN_OUTLET_WARN`;

export const LIBRARY_PROMO_SHOW_ASSIGN_SALES_TYPE_WARN = `${prefix}_SHOW_ASSIGN_SALES_TYPE_WARN`;

export const LIBRARY_PROMO_HIDE_ASSIGN_SALES_TYPE_WARN = `${prefix}_HIDE_ASSIGN_SALES_TYPE_WARN`;

export const LIBRARY_PROMO_SET_PREVIOUS_SALES_TYPE = `${prefix}SET_PREVIOUS_SALES_TYPE`;
